/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AcceptAutoQuotePayload } from '../models/AcceptAutoQuotePayload';
import type { AcceptQuoteResponse } from '../models/AcceptQuoteResponse';
import type { CreateJobRequestPayload } from '../models/CreateJobRequestPayload';
import type { GetJobRequestFileDownloadUrlResponse } from '../models/GetJobRequestFileDownloadUrlResponse';
import type { JobRequest } from '../models/JobRequest';
import type { JobRequestAutoQuoteSummary } from '../models/JobRequestAutoQuoteSummary';
import type { JobRequestCollection } from '../models/JobRequestCollection';
import type { RejectQuotePayload } from '../models/RejectQuotePayload';
import type { RenameJobRequestPayload } from '../models/RenameJobRequestPayload';
import type { SubmitJobRequestToXtrfPayload } from '../models/SubmitJobRequestToXtrfPayload';
import type { UnauthenticatedCreateJobRequestPayload } from '../models/UnauthenticatedCreateJobRequestPayload';
import type { ZipJobRequestTranslatedFilesStatusResponse } from '../models/ZipJobRequestTranslatedFilesStatusResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class JobRequestsService {
    /**
     * Lists job requests for an authenticated current user
     * @returns JobRequestCollection Successful response
     * @throws ApiError
     */
    public static listJobRequests({
        origination,
        pageToken,
        pageSize,
        status,
    }: {
        /**
         * Origination of queried job requests
         */
        origination: any,
        /**
         * Page token
         */
        pageToken?: any,
        /**
         * Page size
         */
        pageSize?: any,
        status?: string,
    }): CancelablePromise<JobRequestCollection> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/jobRequests',
            query: {
                'origination': origination,
                'pageToken': pageToken,
                'pageSize': pageSize,
                'status': status,
            },
            errors: {
                403: `Forbidden`,
                404: `Not found`,
            },
        });
    }
    /**
     * Creates a new job request
     * @returns JobRequest Successfully created job request
     * @throws ApiError
     */
    public static createJobRequest({
        requestBody,
    }: {
        /**
         * Payload for creating a job request
         */
        requestBody?: CreateJobRequestPayload,
    }): CancelablePromise<JobRequest> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/jobRequests',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Creates a new job request. Should be used for public/unauthenticated users.
     * @returns JobRequest Successfully created job request
     * @throws ApiError
     */
    public static unauthenticatedCreateJobRequest({
        requestBody,
    }: {
        /**
         * Payload for creating a job request
         */
        requestBody?: UnauthenticatedCreateJobRequestPayload,
    }): CancelablePromise<JobRequest> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/jobRequests/actions/unauthenticatedCreateJobRequest',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Fetches a job request
     * @returns JobRequest Successful response
     * @throws ApiError
     */
    public static getJobRequest({
        jobRequestId,
    }: {
        /**
         * Job request ID
         */
        jobRequestId: any,
    }): CancelablePromise<JobRequest> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/jobRequests/{jobRequestId}',
            path: {
                'jobRequestId': jobRequestId,
            },
            errors: {
                403: `Forbidden`,
                404: `Not found`,
            },
        });
    }
    /**
     * Fetches an auto quote summary
     * @returns JobRequestAutoQuoteSummary Successful response
     * @throws ApiError
     */
    public static getAutoQuote({
        jobRequestId,
    }: {
        /**
         * Job request ID
         */
        jobRequestId: any,
    }): CancelablePromise<JobRequestAutoQuoteSummary> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/autoQuotes/{jobRequestId}',
            path: {
                'jobRequestId': jobRequestId,
            },
            errors: {
                404: `Not found`,
            },
        });
    }
    /**
     * Submits job request to XTRF
     * @returns any Successfuly accepted request
     * @throws ApiError
     */
    public static submitToXtrf({
        jobRequestId,
        requestBody,
    }: {
        /**
         * Job request ID
         */
        jobRequestId: any,
        /**
         * Payload for submitting a job request to XTRF
         */
        requestBody?: SubmitJobRequestToXtrfPayload,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/jobRequests/{jobRequestId}/actions/submitToXtrf',
            path: {
                'jobRequestId': jobRequestId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                403: `Forbidden`,
                404: `Not found`,
            },
        });
    }
    /**
     * Renames job request
     * @returns any Successful operation
     * @throws ApiError
     */
    public static renameJobRequest({
        jobRequestId,
        requestBody,
    }: {
        /**
         * Job request ID
         */
        jobRequestId: any,
        /**
         * Payload for renaming job request
         */
        requestBody?: RenameJobRequestPayload,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/jobRequests/{jobRequestId}/actions/renameJobRequest',
            path: {
                'jobRequestId': jobRequestId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                403: `Forbidden`,
                404: `Not found`,
            },
        });
    }
    /**
     * Archive the job request
     * @returns void
     * @throws ApiError
     */
    public static archiveJobRequest({
        jobRequestId,
    }: {
        jobRequestId: string,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/jobRequests/{jobRequestId}/actions/archive',
            path: {
                'jobRequestId': jobRequestId,
            },
            errors: {
                400: `Invalid request origination`,
                404: `Job request not found`,
            },
        });
    }
    /**
     * Return temporary download url of job request file
     * @returns GetJobRequestFileDownloadUrlResponse successful operation
     * @throws ApiError
     */
    public static getJobRequestFileDownloadUrl({
        jobRequestId,
        fileKey,
        inline,
    }: {
        jobRequestId: string,
        fileKey: string,
        inline?: boolean,
    }): CancelablePromise<GetJobRequestFileDownloadUrlResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/jobRequests/{jobRequestId}/files/{fileKey}/downloadUrl',
            path: {
                'jobRequestId': jobRequestId,
                'fileKey': fileKey,
            },
            query: {
                'inline': inline,
            },
            errors: {
                400: `Invalid request`,
                404: `Not found`,
            },
        });
    }
    /**
     * Zip job request translated files
     * @returns void
     * @throws ApiError
     */
    public static zipJobRequestTranslatedFiles({
        jobRequestId,
        zipFileName,
    }: {
        /**
         * Job request ID
         */
        jobRequestId: any,
        /**
         * Zip file name
         */
        zipFileName: string,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/jobRequests/{jobRequestId}/actions/zipTranslatedFiles',
            path: {
                'jobRequestId': jobRequestId,
            },
            query: {
                'zipFileName': zipFileName,
            },
            errors: {
                403: `Forbidden`,
                404: `Not found`,
            },
        });
    }
    /**
     * AI post-edit translated files using OpenAI
     * @returns void
     * @throws ApiError
     */
    public static aiPostEditFiles({
        jobRequestId,
        targetLanguageId,
    }: {
        /**
         * Job request ID
         */
        jobRequestId: string,
        /**
         * Optional target language ID to filter files
         */
        targetLanguageId?: number,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/jobRequests/{jobRequestId}/actions/aiPostEditFiles',
            path: {
                'jobRequestId': jobRequestId,
            },
            query: {
                'targetLanguageId': targetLanguageId,
            },
            errors: {
                403: `Forbidden`,
                404: `Not found`,
            },
        });
    }
    /**
     * Get status of job request translated files zipping operation
     * @returns ZipJobRequestTranslatedFilesStatusResponse Successful operation
     * @throws ApiError
     */
    public static getZipTranslatedFilesStatus({
        jobRequestId,
    }: {
        /**
         * Job request ID
         */
        jobRequestId: any,
    }): CancelablePromise<ZipJobRequestTranslatedFilesStatusResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/jobRequests/{jobRequestId}/actions/zipTranslatedFiles/status',
            path: {
                'jobRequestId': jobRequestId,
            },
            errors: {
                403: `Forbidden`,
                404: `Not found`,
            },
        });
    }
    /**
     * Accepts job request's quote
     * @returns AcceptQuoteResponse Successful operation
     * @throws ApiError
     */
    public static acceptQuote({
        jobRequestId,
    }: {
        /**
         * Job request ID
         */
        jobRequestId: any,
    }): CancelablePromise<AcceptQuoteResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/jobRequests/{jobRequestId}/actions/acceptQuote',
            path: {
                'jobRequestId': jobRequestId,
            },
            errors: {
                403: `Forbidden`,
                404: `Not found`,
                409: `Conflict error`,
            },
        });
    }
    /**
     * Rejects job request's quote
     * @returns void
     * @throws ApiError
     */
    public static rejectQuote({
        jobRequestId,
        requestBody,
    }: {
        /**
         * Job request ID
         */
        jobRequestId: any,
        /**
         * Payload for creating a job request
         */
        requestBody?: RejectQuotePayload,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/jobRequests/{jobRequestId}/actions/rejectQuote',
            path: {
                'jobRequestId': jobRequestId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                403: `Forbidden`,
                404: `Not found`,
                409: `Conflict error`,
            },
        });
    }
    /**
     * Accepts job request's auto quote
     * @returns void
     * @throws ApiError
     */
    public static acceptAutoQuote({
        jobRequestId,
        requestBody,
    }: {
        /**
         * Job request ID
         */
        jobRequestId: any,
        requestBody?: AcceptAutoQuotePayload,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/jobRequests/{jobRequestId}/actions/acceptAutoQuote',
            path: {
                'jobRequestId': jobRequestId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                404: `Not found`,
                409: `Conflict error`,
            },
        });
    }
    /**
     * Rejects job request's auto quote
     * @returns void
     * @throws ApiError
     */
    public static rejectAutoQuote({
        jobRequestId,
        requestBody,
    }: {
        /**
         * Job request ID
         */
        jobRequestId: any,
        /**
         * Payload of a job request
         */
        requestBody?: RejectQuotePayload,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/jobRequests/{jobRequestId}/actions/rejectAutoQuote',
            path: {
                'jobRequestId': jobRequestId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                404: `Not found`,
                409: `Conflict error`,
            },
        });
    }
}
